import { stringifyUrl } from "query-string";
export function appendQueryParams(url, queryParams) {
    return stringifyUrl({
        url,
        query: queryParams
    }, {
        skipNull: true,
        sort: false
    });
}
//# sourceMappingURL=appendQueryParams.js.map